import React, { useEffect, useRef, useState } from 'react'
import FilterComponent from '../filter/FilterComponent'
import { useDispatch } from 'react-redux'
import {
    GET_ALL_EXPLORE_DESIGNS,
    GET_FAVOURITE_COUNT,
    SELECT_DESIGN_FOR_FAVOURITE,
    UNSELECT_DESIGN_FOR_FAVOURITE
} from '../../redux_toolkit/@types/thunk.types'
import { ExploreDesignThunks } from '../../redux_toolkit/V3/DesignLab/ExploreDesignThunks'
import {
    useExploreDesigns,
    useExploreDesignsLoading
} from '../../redux_toolkit/V3/DesignLab/ExploreDesignSlice'
import DesignCardView from '../common/DesignCardView'
import ScrollTop from '../common/ScrollTop'
import {
    getUserPreference,
    isPageReachBottom,
    setBreadCrumbRoutes,
    getTotalDashboardCount,
    authUserInfo,
    isPickAndChooseBuyer
} from '../../helpers/Util'
import { closeLoader, openLoader, useLoader } from '../../redux_toolkit/Loader'
import { FilterActionTypes, useFilter } from '../../redux_toolkit/V3/Filter'
import {
    exploreDesignFields,
    generateExploreDesignPageParams
} from '../filter/filterUtil'
import AddToFavourite from '../common/AddToFavourite'
import { useNavigate, Link } from 'react-router-dom'
import {
    ADD_FILTER_FIELDS,
    CLEAR_FILTER_FIELDS
} from '../../redux_toolkit/@types/action.types'
import { DoFavouriteThunk } from '../../redux_toolkit/V3/DoFavourite/DoFavouriteThunk'
import BuildRangeRightSidePanel from '../range/BuildRangeRightSidePanel'
import { FavouriteThunks } from '../../redux_toolkit/Favourite/FavouriteThunks'
import {
    addMixpanelTrackingEvent,
    setSystemUserPreferences
} from '../../services/CommonService'
import { fetchCurrentBuyerRequest } from '../../services/v3/Dashboard/Dashborad'
import { useGlobalState } from '../../redux_toolkit/V3/Common'
import { ReactComponent as CollectionFillIcon } from '../../../assets/icons/collection-fill.svg'
import { ReactComponent as CollectionUnFillIcon } from '../../../assets/icons/collection-unfill.svg'
import { LOADER_COLOR } from '../../constant'
import useDocumentTitle from '../../hooks/userDocumentTitle'
import { fetchFilterFieldsThunk } from '../../redux_toolkit/V3/Filter/FilterOptionThunks'
import LoaderComponent from '../../common/LoaderComponent'

const ExploreDesign = () => {
    const [total, setToal] = useState(null)
    const [showMoreDesign, setShowMoreDesign] = useState(true)
    const [showFavourite, setShowFavourite] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [viewType, setViewType] = useState(null)
    const [designs, setDesigns] = useState([])
    const [backgroundColor, setBackgroundColor] = useState('#068BEE')
    const [filtersCleared, setFiltersCleared] = useState(false)
    const [textdColor, setTextColor] = useState('#FFF')
    const [linkColor, setLinkColor] = useState('#FFF')

    const trackId = useGlobalState()?.productTrackId
    const exploreDesigns = useExploreDesigns()
    const isExploreDesignLoading = useExploreDesignsLoading()
    const isLoading = useRef(null)
    const hasInitialFetch = useRef(false)
    const globalLoader = useLoader()
    const filterStore = useFilter()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const scrollRef = useRef()
    useDocumentTitle('Nitex - Design Lab')

    useEffect(() => {
        onFetchBuyerRequest()
    }, [])

    useEffect(() => {
        const timer = setTimeout(() => {
            setBackgroundColor('#F5F5F5')
            setLinkColor(LOADER_COLOR)
            setTextColor('#21242B')
        }, 3000)
        return () => clearTimeout(timer)
    }, [])

    const onFetchBuyerRequest = async () => {
        const data = await fetchCurrentBuyerRequest()
        setToal(getTotalDashboardCount(data))
    }

    useEffect(() => {
        let type = getUserPreference()?.exploreDesignViewType || 'LARGE_VIEW'
        setViewType(type)
    }, [])

    const setIsDataLoading = (data) => {
        isLoading.current = data
    }

    useEffect(() => {
        dispatch(
            fetchFilterFieldsThunk({
                fieldsType: exploreDesignFields,
                isExploreDesignPage: true
            })
        )
        if (!filterStore?.mainFabricList && !filterStore?.categoryList) {
            dispatch(FilterActionTypes[CLEAR_FILTER_FIELDS]())
            setFiltersCleared(true)
        }
        return () => {
            dispatch(FilterActionTypes[CLEAR_FILTER_FIELDS]())
        }
    }, [])

    useEffect(() => {
        if (filterStore?.mainFabricList || filterStore?.categoryList) {
            setFiltersCleared(true)
        }
    }, [filterStore])

    useEffect(() => {
        setIsDataLoading(globalLoader)
    }, [globalLoader])

    const generateParams = (pageNumber) => {
        let size = 20
        if (pageNumber === 0) size = 40
        if (pageNumber === 1) pageNumber = 2
        let isExploreMore = filterStore?.isMoreExplore ? 'true' : 'false'
        return `?page=${pageNumber}&size=${size}&sort=id,desc&isMoreExplore=${isExploreMore}`
    }

    const fetchExploreDesigns = async (pageNumber) => {
        const requetBody = generateExploreDesignPageParams(filterStore)
        dispatch(
            ExploreDesignThunks[GET_ALL_EXPLORE_DESIGNS](
                generateParams(pageNumber),
                filterStore?.isMoreExplore,
                requetBody
            )
        )
    }

    useEffect(() => {
        if (!hasInitialFetch.current) {
            fetchExploreDesigns(0)
            hasInitialFetch.current = true
        }
        document.addEventListener('scroll', handleScroll)
        return () => {
            document.removeEventListener('scroll', handleScroll)
        }
    }, [filterStore, filtersCleared])

    useEffect(() => {
        if (hasInitialFetch.current && filtersCleared) {
            fetchExploreDesigns(0)
        }
    }, [filterStore])

    const handleScroll = () => {
        if (isPageReachBottom()) {
            let { totalElements, currentPage, data } = scrollRef.current
            if (
                totalElements > 0 &&
                totalElements !== data.length &&
                !isLoading.current
            ) {
                fetchExploreDesigns(currentPage + 1)
            }
        }
    }

    useEffect(() => {
        setDesigns(exploreDesigns?.data)
        scrollRef.current = exploreDesigns
    }, [exploreDesigns])

    const toggleIsFavourite = async (bool, designInfo, isShowFav = true) => {
        if (designInfo?.availabilityStatus !== 'Sold' && !designInfo?.isSold) {
            setShowFavourite(true)
        } else {
            setShowFavourite(false)
        }
        await dispatch(
            DoFavouriteThunk[SELECT_DESIGN_FOR_FAVOURITE](designInfo, trackId)
        )
        await dispatch(FavouriteThunks[GET_FAVOURITE_COUNT]())
    }

    const renderDesigns = () => {
        return designs?.map((item, i) => {
            return (
                <React.Fragment key={`single_item_${i}`}>
                    <DesignCardView
                        designInfo={item}
                        triggerIsFavourite={toggleIsFavourite}
                    />
                </React.Fragment>
            )
        })
    }

    const renderExploreMore = () => {
        if (!scrollRef.current) return
        let { totalPages, currentPage } = scrollRef.current
        if (currentPage + 1 === totalPages && showMoreDesign) {
            return (
                <div className='more-design mt-16 mb-8 d-flex justify-center items-center'>
                    <p className='regular-16 mr-6'>
                        Do you want to explore more designs?
                    </p>
                    <button
                        className='button primary mr-3'
                        onClick={() => {
                            dispatch(
                                FilterActionTypes[ADD_FILTER_FIELDS]({
                                    data: { isMoreExplore: true }
                                })
                            )
                            addMixpanelTrackingEvent({}, 'BUYER_EXPLORE_MORE')
                        }}
                    >
                        Yes
                    </button>
                    <button
                        className='button secondary'
                        onClick={() => setShowMoreDesign(false)}
                    >
                        No
                    </button>
                </div>
            )
        }
    }

    const routeCollectionPage = () => {
        dispatch(FilterActionTypes[CLEAR_FILTER_FIELDS]())
        let newRoute = '/shared-collection'
        let visitingRoutes = [
            {
                key: '/design-lab',
                value: 'Design Lab'
            },
            {
                key: newRoute,
                value: 'Collections'
            }
        ]

        setBreadCrumbRoutes(visitingRoutes)
        navigate(newRoute)
        addMixpanelTrackingEvent({}, 'BUYER_EXCLUSIVE_FOR_YOU')
    }

    const onCloseModal = () => {
        setOpenModal(false)
    }

    const toggleDesignViewType = async () => {
        try {
            let type =
                getUserPreference()?.exploreDesignViewType === 'NARROW_VIEW'
                    ? 'LARGE_VIEW'
                    : 'NARROW_VIEW'
            dispatch(openLoader())
            await setSystemUserPreferences({
                exploreDesignViewType: type
            })
            setViewType(type)
            dispatch(closeLoader())
        } catch (e) {
            dispatch(closeLoader())
        }
    }

    const renderViewTypeWiseIcon = () => {
        let type =
            getUserPreference()?.exploreDesignViewType === 'NARROW_VIEW'
                ? 'LARGE_VIEW'
                : 'NARROW_VIEW'
        if (type !== 'NARROW_VIEW') {
            return <CollectionFillIcon />
        } else {
            return <CollectionUnFillIcon />
        }
    }

    const getCount = (type, title) => {
        if (total?.[type]?.RUNNING > 0) {
            return total?.[type]?.RUNNING > 1
                ? `${total?.[type]?.RUNNING} ${title.toLowerCase()}s`
                : `${total?.[type]?.RUNNING} ${title.toLowerCase()}`
        } else return null
    }

    const quoteCount = getCount('quotes', 'quote')
    const sampleCount = getCount('sample', 'sample')
    const orderCount = getCount('order', 'order')

    const counts = [quoteCount, sampleCount, orderCount]
        .filter(Boolean)
        .join(', ')

    const renderLink = () => (
        <Link
            style={{ color: linkColor }}
            to='/dashboard?active=QUOTES&status=RUNNING'
            onClick={() =>
                addMixpanelTrackingEvent({}, 'BUYER_DESIGN_LAB_SEE_ALL')
            }
        >
            See all
        </Link>
    )

    const renderText = `You currently have ${counts}. `

    const renderTopBar = () => {
        return (
            <div
                style={{ backgroundColor: backgroundColor }}
                className={'bg text-center py-2 px-4'}
            >
                <p style={{ color: textdColor }} className='text-sm'>
                    {renderText}
                    {renderLink()}
                </p>
            </div>
        )
    }

    const getNumberCount = () => {
        let isValid = false
        if (total?.['quotes']?.RUNNING > 0) {
            isValid = true
        }
        if (total?.['sample']?.RUNNING > 0) {
            isValid = true
        }
        if (total?.['order']?.RUNNING > 0) {
            isValid = true
        }
        return isValid
    }

    const getBuyerWiseFilterFields = (exploreDesignFields) => {
        return !isPickAndChooseBuyer()
            ? (({ PRICE_RANGE, ...rest }) => rest)(exploreDesignFields)
            : exploreDesignFields
    }

    return (
        <LoaderComponent loading={isExploreDesignLoading}>
            {total && getNumberCount() && renderTopBar()}
            <FilterComponent
                requiredFields={getBuyerWiseFilterFields(exploreDesignFields)}
                filteredDataLength={designs?.length}
                extraClass={'on-explore-design'}
            >
                <button
                    className='button icon-only boder-0'
                    onClick={toggleDesignViewType}
                >
                    {renderViewTypeWiseIcon()}
                </button>

                <button
                    className='button secondary-blue round sm'
                    onClick={routeCollectionPage}
                >
                    <span className='mr-2'>Exclusive for you</span>
                </button>
            </FilterComponent>
            <div className='page-content relative px-4'>
                <AddToFavourite
                    isVisible={showFavourite}
                    setIsVisible={setShowFavourite}
                />
                <div
                    className={`design-list-container pb-3 ${
                        viewType === 'NARROW_VIEW' ? 'image-view' : ''
                    }`}
                >
                    {renderDesigns()}
                </div>
                {designs?.length === 0 && (
                    <div className='epmpty-state py-40 text-center m-auto'>
                        <h3 className='text-xl weight-700 gray_400'>
                            No results found
                        </h3>
                        <p className='text-base gray_400'>
                            Please try a different filter
                        </p>
                    </div>
                )}
            </div>
            {!Object.keys(filterStore).length &&
                !filterStore?.isMoreExplore &&
                renderExploreMore()}

            <ScrollTop />
            {openModal && (
                <BuildRangeRightSidePanel
                    openModal={openModal}
                    onCloseModal={onCloseModal}
                />
            )}
        </LoaderComponent>
    )
}

export default ExploreDesign
